import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=07a871a7&scoped=true"
import script from "./VideoCard.vue?vue&type=script&lang=js"
export * from "./VideoCard.vue?vue&type=script&lang=js"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=07a871a7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a871a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a871a7')) {
      api.createRecord('07a871a7', component.options)
    } else {
      api.reload('07a871a7', component.options)
    }
    module.hot.accept("./VideoCard.vue?vue&type=template&id=07a871a7&scoped=true", function () {
      api.rerender('07a871a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoCard/VideoCard.vue"
export default component.exports